import { Component, Input, OnInit, OnDestroy, inject, ChangeDetectionStrategy } from '@angular/core';

import { Observable, Subscription, map, take, filter } from 'rxjs';

import { CmsContent, CmsTarget } from '@fcom/core-api';
import { unsubscribe } from '@fcom/core/utils/unsubscribe';
import { DataCloudService } from '@fcom/common/datacloud/services/datacloud.service';
import { ConfigService } from '@fcom/core';

import { toLinkData } from '../../services/template/data-mappers';

export const ALL_DESTINATIONS_LINK_MASTER_CONTENT_ID = 1239748;

@Component({
  selector: 'cms-text-link',
  template: `
    <fin-text-link
      class="mr-large-b block"
      [target$]="cmsTarget$"
      [teaserTitle$]="content$ | finMap: 'teaserTitle'"
      [colorClass]="colorClass"
      (click)="onClick()"
    />
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CmsTextLinkComponent implements OnInit, OnDestroy {
  private dataCloudService = inject(DataCloudService);
  private configService = inject(ConfigService);

  @Input()
  content$: Observable<CmsContent>;
  @Input()
  colorClass: string;

  cmsTarget$: Observable<CmsTarget>;

  private subscription: Subscription = new Subscription();

  ngOnInit(): void {
    this.cmsTarget$ = this.content$.pipe(
      map((content) =>
        toLinkData({
          ...content.target,
          url:
            // for the duration of the AB test, we patch the url with round trip prices always everywhere and for all customers
            this.configService.cfg.isPersonalisedDestinationsEnabled &&
            content.masterContentId === ALL_DESTINATIONS_LINK_MASTER_CONTENT_ID
              ? `${content.target.url}?roundTripPrices=true`
              : content.target.url,
        })
      )
    );
  }

  ngOnDestroy(): void {
    this.subscription = unsubscribe(this.subscription);
  }

  onClick(): void {
    this.subscription.add(
      this.content$
        .pipe(
          take(1),
          filter((content) => content.masterContentId === ALL_DESTINATIONS_LINK_MASTER_CONTENT_ID)
        )
        .subscribe(() => {
          this.dataCloudService.destinationListAllDestinationsClick();
        })
    );
  }
}
